export const CONTACT_PAGE_SIZE = 25;
export const CONTACT_SEARCH_DEBOUNCE_MS = 300;
export const CONTACT_TICKETS_LIMIT = 5;
export const ORGANISATION_OPTIONS_LIMIT = 200;

/** Search params of the Contacts screen (`?filter=pending&org=<id>&q=…`); the organisations list links in with them. */
export const CONTACT_PARAM = { filter: "filter", organisation: "org" } as const;

export const CONTACT_CHIPS = ["all", "pending", "admins", "unlinked", "blocked"] as const;
export type ContactChip = (typeof CONTACT_CHIPS)[number];

export function isContactChip(value: string | null): value is ContactChip {
  return CONTACT_CHIPS.some((chip) => chip === value);
}

/** Chips that only make sense when clients belong to organisations (hidden for B2C workspaces). */
export const ORGANISATION_CHIPS: readonly ContactChip[] = ["admins", "unlinked"];

/** Verification string the server stores (`ContactVerification`). */
export const CONTACT_VERIFIED = "verified";
